export default __webpack_public_path__ + "static/videobg-e9e7b332c1a6732a3f97155e118334df.mp4";